import React, { ReactNode, useMemo } from 'react'
import { DBliteContext } from './context.ts'
import { SQLocalKysely } from 'sqlocal/kysely'
import { Kysely } from 'kysely'

export interface DbliteProviderProps {
  db: Kysely<unknown>
  sqlite: SQLocalKysely
  children: ReactNode
}

/**
 * Provider component for wa-sqlite database access
 */
export function DBliteProvider({
  db,
  sqlite,
  children,
}: DbliteProviderProps): React.ReactElement {
  const value = useMemo(
    () => ({
      db,
      sqlite,
    }),
    [db, sqlite]
  )
  return (
    <DBliteContext.Provider value={value}>
      {children}
    </DBliteContext.Provider>
  )
}
